import React, { useState, useEffect } from "react";
import { adminAPI } from "../../services/api";
import { Search, Shield, ShieldOff, Trash2 } from "lucide-react";
import "./Admin.css";

const UserManager = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await adminAPI.getUsers();
      setUsers(res.data);
    } catch (err) {
      console.error("Failed to fetch users", err);
    } finally {
      setLoading(false);
    }
  };

  const filteredUsers = users.filter(
    (user) =>
      user.full_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.organization?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="admin-page">
      <div className="admin-section-header" style={{ marginBottom: "24px" }}>
        <h1 style={{ fontSize: "1.5rem", fontWeight: "700" }}>
          User Management
        </h1>
        <p style={{ color: "var(--admin-text-sub)" }}>
          Manage all registered users and their permissions
        </p>
      </div>

      <div className="admin-card">
        <div className="card-header" style={{ padding: "16px 24px" }}>
          <div
            className="admin-search-bar"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              background: "#f1f5f9",
              padding: "8px 16px",
              borderRadius: "8px",
              width: "100%",
              maxWidth: "400px",
            }}
          >
            <Search size={18} color="#64748b" />
            <input
              type="text"
              placeholder="Search users..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                border: "none",
                background: "transparent",
                outline: "none",
                width: "100%",
                fontSize: "0.875rem",
              }}
            />
          </div>
        </div>

        <div className="admin-table-container">
          <table className="admin-table">
            <thead>
              <tr>
                <th>User</th>
                <th>Organization</th>
                <th>Pass Type</th>
                <th>Status</th>
                <th>Joined</th>
                {/* <th>Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan="6"
                    style={{ textAlign: "center", padding: "40px" }}
                  >
                    Loading...
                  </td>
                </tr>
              ) : filteredUsers.length === 0 ? (
                <tr>
                  <td
                    colSpan="6"
                    style={{ textAlign: "center", padding: "40px" }}
                  >
                    No users found.
                  </td>
                </tr>
              ) : (
                filteredUsers.map((user) => (
                  <tr key={user.id}>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                        }}
                      >
                        <div
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            background: "#e2e8f0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "0.75rem",
                            fontWeight: "600",
                          }}
                        >
                          {user.full_name?.charAt(0)}
                        </div>
                        <div>
                          <div style={{ fontWeight: "600", color: "#0f172a" }}>
                            {user.full_name}
                          </div>
                          <div
                            style={{ fontSize: "0.75rem", color: "#64748b" }}
                          >
                            {user.email}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>{user.organization || "-"}</td>
                    <td>
                      <span
                        className="admin-badge"
                        style={{ background: "#f1f5f9", color: "#475569" }}
                      >
                        {user.pass_type}
                      </span>
                    </td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        {user.is_admin ? (
                          <span
                            className="admin-badge"
                            style={{ background: "#dbeafe", color: "#1e40af" }}
                          >
                            Admin
                          </span>
                        ) : (
                          <span
                            className="admin-badge"
                            style={{ background: "#f1f5f9", color: "#64748b" }}
                          >
                            User
                          </span>
                        )}
                      </div>
                    </td>
                    <td style={{ color: "#64748b", fontSize: "0.75rem" }}>
                      {new Date(user.created_at).toLocaleDateString()}
                    </td>
                    {/* <td>
                      <div style={{ display: "flex", gap: "8px" }}>
                        <button
                          className="btn-icon"
                          title={user.is_admin ? "Remove Admin" : "Make Admin"}
                        >
                          {user.is_admin ? (
                            <ShieldOff size={16} />
                          ) : (
                            <Shield size={16} />
                          )}
                        </button>
                        <button
                          className="btn-icon text-danger"
                          title="Delete User"
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                    </td> */}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default UserManager;
